module.exports = __webpack_public_path__ + "images/ds-cme-bg-blog-banner.webp";